export const name = 'consentPolicyService' as const
